export default __webpack_public_path__ + "static/media/redVector.0490afaa.svg";